<template>
<EntityReport entity="ReportElektro" />
</template>

<script>
export default {

}
</script>
